<template>
	<app-button
		v-if="!expanded"
		size="x-small"
		theme="outline"
		data-testid="expand-all"
		@click="emit('expandAll')">
		<app-icon :icon="['fas', 'fa-angles-down']" />
	</app-button>

	<app-button
		v-else
		size="x-small"
		theme="info"
		data-testid="close-all"
		@click="emit('closeAll')">
		<app-icon :icon="['fas', 'fa-angles-up']" />
	</app-button>
</template>

<script lang="ts" setup>
	import { onMounted } from 'vue'

	defineProps({
		expanded: Boolean
	})

	onMounted(() => {
		emit('expandAll')
	})

	const emit = defineEmits(['closeAll', 'expandAll'])
</script>
